export const LINK_ADD_WIDGET = 'Add Widget';
export const LINK_INITIATE = 'Initiate';
export const LABEL = 'label';
